const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时聚合更新',
    desc: '7×24小时全天候监控全网娱乐动态，第一时间聚合最新吃瓜资讯。无论是深夜突发新闻还是凌晨热议话题，51吃瓜网入口都不会让您错过任何精彩瞬间，确保您通过51吃瓜网站入口始终获取最新内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定访问',
    desc: '提供稳定的51吃瓜官方入口与51吃瓜最新地址，解决51吃瓜网怎么进的困扰。多节点部署保障访问畅通，智能路由确保最佳连接体验。无论何时何地，51吃瓜网在线访问始终稳定可靠，让吃瓜不中断。',
  },
  {
    icon: 'ri-compasses-line',
    title: '精准内容导航',
    desc: '15+内容分类、热度榜单、专题合集等多维度内容组织方式，帮您在海量信息中快速定位感兴趣的吃瓜话题。从娱乐八卦到影视追踪，从网红动态到音乐资讯，51吃瓜网入口让内容发现更高效。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">平台特色</h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              为什么选择51吃瓜网入口？三大核心优势为您带来最好的吃瓜体验
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {features.map((feature, idx) => (
              <div key={idx} className="text-center p-6 md:p-8 bg-background-100 rounded-lg">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-5">
                  <i className={`${feature.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-3">{feature.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}